module.exports = __webpack_public_path__ + "static/ION4-6b79cdc6ed14a1d29c7fdc9592caee17.mp4";